import { TaxInfoForm } from "@client/components/TaxInfoForm";
import { BackButton, PageContainer } from "@client/components/ui";
import { createFileRoute } from "@tanstack/react-router";
import { FileText } from "lucide-react";

export const Route = createFileRoute("/(protected)/settings/tax")({
	component: TaxPage,
});

function TaxPage() {
	return (
		<PageContainer maxWidth="narrow">
			<BackButton to="/settings" label="Back to Settings" />

			{/* Header */}
			<div className="mb-8">
				<div className="flex items-center gap-3">
					<FileText className="h-8 w-8 text-primary" />
					<h1 className="font-semibold text-3xl tracking-tight">
						Tax Information
					</h1>
				</div>
				<p className="mt-1 text-muted-foreground">
					Manage tax information for invoices and billing
				</p>
			</div>

			<TaxInfoForm />
		</PageContainer>
	);
}
